/*
 * Copyright (C) 2018 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */

import imgAlt from './img-alt';
import imgAltFilename from './img-alt-filename';
import tableCaption from './table-caption';
import tableHeader from './table-header';
import tableHeaderScope from './table-header-scope';
import smallTextContrast from './small-text-contrast';
import largeTextContrast from './large-text-contrast';
import adjacentSameLinks from './adjacent-links';
import headingsSequence from './headings-sequence';
import imageAltLength from './img-alt-length';
import paragraphsForHeadings from './paragraphs-for-headings';
import listStructure from './list-structure';
import headingsStartAtH2 from './headings-start-at-h2';
export default [imgAlt, imgAltFilename, tableCaption, tableHeader, tableHeaderScope, smallTextContrast, largeTextContrast, adjacentSameLinks, headingsSequence, imageAltLength, paragraphsForHeadings, listStructure, headingsStartAtH2];